import React, { useEffect, useState } from 'react'

const useOnScreen = (ref, loaded = true, rootMargin = '0px') => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (loaded) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setIsVisible(entry.isIntersecting)
        },
        {
          rootMargin,
        }
      )

      const currentElement = ref?.current
      observer.observe(currentElement)

      return () => {
        observer.disconnect()
      }
    }
  }, [loaded])

  return isVisible
}

export default useOnScreen
